import {
  all, call, fork, put, takeEvery,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';
import {
  destroy, startSubmit, setSubmitFailed, setSubmitSucceeded,
} from 'redux-form';

// api
import { create, get } from '../../sources/api/client';
import noteService from '../../sources/api/noteService';
import chapterService from '../../sources/api/chapterService';

// constants
import { NOTE_BULK_CREATE, NOTE_BULK_CREATE_INIT } from '../../constants/noteTypes';
import { CURRENT_CHAPTER_FETCH } from '../../constants/chapterTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { noteSchema } from '../../schemas/note';
import { chapterSchema } from '../../schemas/chapter';

export function* noteBulkCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const FORM = 'tagPnmForm';
  const { payload } = action;

  let values;
  const options = {};

  if (payload.bulkCreate) {
    values = payload.items;
    options.query = { chapter: payload.chapter };
  } else if (payload.import) {
    values = payload.items;
    options.query = {
      chapter: payload.chapter,
      import:  payload.import,
    };
  } else {
    values = payload;
  }

  yield put(startSubmit(FORM));

  try {
    yield* httpSaga(NOTE_BULK_CREATE, call(create, noteService, values, options), {
      schema: noteSchema,
    });

    if (payload.import) {
      yield* httpSaga(CURRENT_CHAPTER_FETCH, call(get, chapterService, payload.chapter), {
        schema: chapterSchema,
      });
    }

    yield put(setSubmitSucceeded(FORM));
    yield put(destroy(FORM));
  } catch (err) {
    yield put(setSubmitFailed(FORM));
    yield put(error(NOTE_BULK_CREATE, err));
  } finally {
    yield put(doneIndicator(NOTE_BULK_CREATE));
  }
}

export function* watchNoteBulkCreate() {
  yield takeEvery(NOTE_BULK_CREATE_INIT, noteBulkCreate);
}

export default function* root() {
  yield all([
    fork(watchNoteBulkCreate),
  ]);
}
